import { useSidePopout } from 'modules/layout';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { getSearchItemCategoryLabel, getSearchItemLocation } from './helper';
import { ItemWrapper, StyledItemCategory, StyledItemNumber } from './styled';

export interface SearchItemProps {
  itemCategory: string;
  itemNumber: string;
}

export const SearchItem: React.FC<SearchItemProps> = ({
  itemCategory,
  itemNumber,
}) => {
  const { closePopout } = useSidePopout();
  const history = useHistory();

  const handleNavigation = () => {
    const location = getSearchItemLocation(itemCategory);
    history.push({
      pathname: location,
      state: { itemId: itemNumber },
    });

    closePopout();
  };

  return (
    <ItemWrapper onClick={() => handleNavigation()}>
      <StyledItemCategory>
        {getSearchItemCategoryLabel(itemCategory)}
      </StyledItemCategory>
      <StyledItemNumber>{itemNumber}</StyledItemNumber>
    </ItemWrapper>
  );
};
